import { render } from "./baseconfirmdialog.vue?vue&type=template&id=df5cdd70"
import script from "./baseconfirmdialog.vue?vue&type=script&lang=js"
export * from "./baseconfirmdialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__